import gql from "graphql-tag";

export default gql`
  query CustomerUsers($offset: Int, $limit: Int, $customerId: ID) {
    customerUsers(offset: $offset, limit: $limit, customerId: $customerId) {
      items {
        id
        username
        name
      }
      total
    }
  }
`;
